module.exports = __webpack_public_path__ + "img/window-close.50d88833.svg";